
import ChannelForCommon from '@/modules/in/Channel.common.vue'
import TheCopyButton from '@/modules/in/components/TheCopyButton.vue'
import TheExchange from '@/modules/in/components/TheExchange.vue'
import TheSelect from '@/modules/in/components/TheSelect.vue'
import { readSkyPayCode } from '@/modules/in/in.api'
import In from '@/modules/in/In.vue'
import { defineComponent, shallowRef } from 'vue'
import { ResponseResult } from 'essential/net/http/makeRequestBy'
import { useRouter } from 'vue-router'
import { Data } from '@/types'

export default defineComponent({
  name: 'ChannelFor61',
  components: {
    ChannelForCommon,
    In,
    TheSelect,
    TheExchange,
    TheCopyButton,
  },
  setup () {
    const channels = [
      'GCash', 'PayMaya', 'TrueMoney', 'ShopeePay', '7-Eleven', 'RD', 'MLhuillier',
    ]
    const router = useRouter()
    const code = shallowRef('------------------')
    const channel = shallowRef(channels[0])
    const useCustomChannel = shallowRef(false)

    readSkyPayCode()
      .then(resp => {
        code.value = resp.contractnumber
      })
      .catch((e: ResponseResult) => {
        if (e.c === '300040') {
          router.replace({ name: 'fillInBaseFormFor63' })
        }
      })

    const redirect = (params: Data) => {
      if (params.payChannel === 'PH_SKYPAY') {
        useCustomChannel.value = true
        return false
      }
    }

    return {
      code,
      channels,
      channel,
      useCustomChannel,
      redirect,
    }
  },
})
